<!-- <yt-fw-default-update-buttons (SaveItemClicked)="Save()" (CloseItemClicked)="Close()" (AddItemClicked)="AddItem()"></yt-fw-default-update-buttons> -->
<yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>
<yt-company-update #baseUpdate></yt-company-update>